import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { PageHeader, Surface, Empty } from "../components/Primitives";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function Suppliers() {
  const { user } = useAuth();
  const canEdit = user?.role === "admin" || user?.role === "user";
  const [rows, setRows] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ name:"", contact:"", phone:"", email:"", address:"" });

  const load = async () => setRows((await api.get("/suppliers")).data);
  useEffect(()=>{load();},[]);
  const submit = async e => { e.preventDefault();
    try { await api.post("/suppliers", form); toast.success("Fournisseur créé"); setShow(false); setForm({name:"",contact:"",phone:"",email:"",address:""}); load(); }
    catch(e){ toast.error(formatApiError(e.response?.data?.detail)); } };
  const remove = async id => { if(!window.confirm("Supprimer ?"))return; await api.delete(`/suppliers/${id}`); toast.success("Supprimé"); load(); };

  return (
    <div className="space-y-6">
      <PageHeader title="Fournisseurs" subtitle="Réseau d'approvisionnement"
        actions={canEdit && <button data-testid="new-supplier-btn" className="btn-primary flex items-center gap-2" onClick={()=>setShow(!show)}><Plus size={14}/>Nouveau</button>}
      />
      {show && (
        <Surface title="Nouveau fournisseur">
          <form onSubmit={submit} className="p-5 grid grid-cols-2 md:grid-cols-3 gap-4">
            <div className="col-span-2"><label className="label-mono block mb-1.5">Nom</label><input data-testid="supplier-name" required className="input-base" value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/></div>
            <div><label className="label-mono block mb-1.5">Contact</label><input className="input-base" value={form.contact} onChange={e=>setForm({...form,contact:e.target.value})}/></div>
            <div><label className="label-mono block mb-1.5">Téléphone</label><input className="input-base" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})}/></div>
            <div><label className="label-mono block mb-1.5">Email</label><input type="email" className="input-base" value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/></div>
            <div><label className="label-mono block mb-1.5">Adresse</label><input className="input-base" value={form.address} onChange={e=>setForm({...form,address:e.target.value})}/></div>
            <div className="col-span-full flex gap-2"><button data-testid="submit-supplier" type="submit" className="btn-primary">Créer</button><button type="button" className="btn-ghost" onClick={()=>setShow(false)}>Annuler</button></div>
          </form>
        </Surface>
      )}
      <Surface>
        {rows.length === 0 ? <Empty/> : (
          <table className="data-table">
            <thead><tr><th>Nom</th><th>Contact</th><th>Téléphone</th><th>Email</th>{canEdit && <th></th>}</tr></thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id}>
                  <td className="font-medium">{r.name}</td>
                  <td>{r.contact || "—"}</td>
                  <td className="font-data text-[var(--text-muted)]">{r.phone || "—"}</td>
                  <td className="font-data text-[var(--text-muted)]">{r.email || "—"}</td>
                  {canEdit && <td><button onClick={()=>remove(r.id)} className="text-[var(--text-muted)] hover:text-[var(--neon-pink)]"><Trash2 size={14}/></button></td>}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Surface>
    </div>
  );
}
